import {
  confirmReceiptData,
  getGochiKidReceiptDetailData,
  getGochiKidReceiptListData,
  settingGochiKidReceiptGroupData,
  settingGochiKidReceiptShopData
} from '../libs/apis/GochiKidReceiptApi';

export const GET_GOCHI_KID_RECEIPT_DETAIL_REQUEST =
  'GET_GOCHI_KID_RECEIPT_DETAIL_REQUEST';
export const GET_GOCHI_KID_RECEIPT_DETAIL_SUCCESS =
  'GET_GOCHI_KID_RECEIPT_DETAIL_SUCCESS';
export const GET_GOCHI_KID_RECEIPT_DETAIL_FAILURE =
  'GET_GOCHI_KID_RECEIPT_DETAIL_FAILURE';

export const GET_GOCHI_KID_RECEIPT_LIST_REQUEST =
  'GET_GOCHI_KID_RECEIPT_LIST_REQUEST';
export const GET_GOCHI_KID_RECEIPT_LIST_SUCCESS =
  'GET_GOCHI_KID_RECEIPT_LIST_SUCCESS';
export const GET_GOCHI_KID_RECEIPT_LIST_FAILURE =
  'GET_GOCHI_KID_RECEIPT_LIST_FAILURE';

export const CONFIRM_RECEIPT_GOCHI_KID_REQUEST =
  'CONFIRM_RECEIPT_GOCHI_KID_REQUEST';
export const CONFIRM_RECEIPT_GOCHI_KID_SUCCESS =
  'CONFIRM_RECEIPT_GOCHI_KID_SUCCESS';
export const CONFIRM_RECEIPT_GOCHI_KID_FAILURE =
  'CONFIRM_RECEIPT_GOCHI_KID_FAILURE';

export const SETTING_GOCHI_KID_RECEIPT_GROUP_REQUEST =
  'SETTING_GOCHI_KID_RECEIPT_GROUP_REQUEST';
export const SETTING_GOCHI_KID_RECEIPT_GROUP_SUCCESS =
  'SETTING_GOCHI_KID_RECEIPT_GROUP_SUCCESS';
export const SETTING_GOCHI_KID_RECEIPT_GROUP_FAILURE =
  'SETTING_GOCHI_KID_RECEIPT_GROUP_FAILURE';

export const SETTING_GOCHI_KID_RECEIPT_SHOP_REQUEST =
  'SETTING_GOCHI_KID_RECEIPT_SHOP_REQUEST';
export const SETTING_GOCHI_KID_RECEIPT_SHOP_SUCCESS =
  'SETTING_GOCHI_KID_RECEIPT_SHOP_SUCCESS';
export const SETTING_GOCHI_KID_RECEIPT_SHOP_FAILURE =
  'SETTING_GOCHI_KID_RECEIPT_SHOP_FAILURE';

export const getGochiKidReceiptDetail = receiptId => dispatch => {
  dispatch({ type: GET_GOCHI_KID_RECEIPT_DETAIL_REQUEST });
  return getGochiKidReceiptDetailData(receiptId)
    .then(response =>
      dispatch({
        type: GET_GOCHI_KID_RECEIPT_DETAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHI_KID_RECEIPT_DETAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGochiKidReceiptList = params => dispatch => {
  dispatch({ type: GET_GOCHI_KID_RECEIPT_LIST_REQUEST });
  return getGochiKidReceiptListData(params)
    .then(response =>
      dispatch({
        type: GET_GOCHI_KID_RECEIPT_LIST_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHI_KID_RECEIPT_LIST_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const confirmReceipt = params => dispatch => {
  dispatch({ type: CONFIRM_RECEIPT_GOCHI_KID_REQUEST });
  return confirmReceiptData(params)
    .then(response =>
      dispatch({
        type: CONFIRM_RECEIPT_GOCHI_KID_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: CONFIRM_RECEIPT_GOCHI_KID_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const settingGochiKidReceiptGroup = params => dispatch => {
  dispatch({ type: SETTING_GOCHI_KID_RECEIPT_GROUP_REQUEST });
  return settingGochiKidReceiptGroupData(params)
    .then(response =>
      dispatch({
        type: SETTING_GOCHI_KID_RECEIPT_GROUP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: SETTING_GOCHI_KID_RECEIPT_GROUP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const settingGochiKidReceiptShop = params => dispatch => {
  dispatch({ type: SETTING_GOCHI_KID_RECEIPT_SHOP_REQUEST });
  return settingGochiKidReceiptShopData(params)
    .then(response =>
      dispatch({
        type: SETTING_GOCHI_KID_RECEIPT_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: SETTING_GOCHI_KID_RECEIPT_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
